export default __webpack_public_path__ + "static/media/carousel-img-3.7076916a.png";